export default "__VITE_ASSET__DLvKrQdf__"